import React, { useState, useEffect } from 'react';
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import socketIOClient from 'socket.io-client';
import UtilsService from '../../../MobileExchenger/elements/utilsService';
import { v4 as uuidV4 } from 'uuid';
import './ProviderLazyLoad.css';

export default function ProviderLazyLoad () {
    const [state, setState] = useState({
        requestId: uuidV4(),

        inCurrencyCode: null,
        outCurrencyCode: null,
        payway: null,
        amount: null,
        amountSide: true,

        loaderTotalProviders: 0,
        loaderCounter: 0
    });

    const [variantsArray, setVariantsArray] = useState([]);

    useEffect(() => {
        const socket = socketIOClient(config.backendUrl + '?requestId=' + state.requestId, { transports: ['websocket'] })

        socket.on('getProviderData', (providerData) => {
            setVariantsArray(variantsArray => [ ...variantsArray, providerData ]);
            setState(state => { return { ...state, loaderCounter: state.loaderCounter + 1 }; });
        });

        socket.on('setLoaderTotalProviders', (loaderTotalProviders) => setState(state => { return { ...state, loaderTotalProviders }; }) );

    }, []);

    const inputChangeHandler = (param) => (event) => {
        const newState = { ...state };
        newState[ param ] = event.target.value;
        setState(() => { return newState; });
    };

    const amountSideButtonHandler = () => setState(state => { return { ...state, amountSide: !state.amountSide }; });

    const findButtonHandler = async () => {
        setVariantsArray(() => []);
        setState(state => { return { ...state, loaderTotalProviders: 0, loaderCounter: 0 }; });

        const body = {
            inCurrencyCode: state.inCurrencyCode,
            outCurrencyCode: state.outCurrencyCode,
            paywayCode: state.payway,
            amountData: {
                amount: parseFloat(state.amount),
                side: state.amountSide ? 'IN' : 'OUT'
            },
            cashbackToken: '4MkQ4RTk',
            requestId: state.requestId,
            sign: {
                message: '1598605828000',
                messageHash: 'example',
                signature: 'example'
            }
        };

        axios.post(config.backendUrl + '/provider/get-profit-providers', body)
        .catch(error => {
            console.log(error.response.data);
            alert(error.message);
        });
    };

    const renderControl = () => {
        return (
            <div className="providerLazyLoad__control_wrapper">
                <input type="text" placeholder="in currency" value={ state.inCurrencyCode || '' } onChange={ inputChangeHandler('inCurrencyCode') } />
                <input type="text" placeholder="out currency" value={ state.outCurrencyCode || '' } onChange={ inputChangeHandler('outCurrencyCode') } />
                <input type="text" placeholder="payway" value={ state.payway || '' } onChange={ inputChangeHandler('payway') } />
                <div>
                    <input type="number" placeholder="amount" value={ state.amount || '' } onChange={ inputChangeHandler('amount') } />
                    <button onClick={ amountSideButtonHandler } >{ state.amountSide ? 'IN' : 'OUT' }</button>
                </div>
                <button onClick={ findButtonHandler } >Find</button>
            </div>
        );
    };

    const renderPercents = () => {
        if (state.loaderTotalProviders === 0) { return; }
        const percentage = UtilsService.cutNumber(((100 * state.loaderCounter) / state.loaderTotalProviders), 0);

        return (
            <div className="providerLazyLoad__control_wrapper providerLazyLoad__loader_wrapper">
                { percentage }%
            </div>
        );
    };

    const sortVariants = (variantsArray) => {
        let withEquivalentData = variantsArray.filter(variant => variant.equivalentData && variant.equivalentData.status === 'SUCCESS');
        const withoutEquivalentData = variantsArray.filter(variant => !variant.equivalentData || variant.equivalentData.status !== 'SUCCESS');
        const amountSide = state.amountSide ? 'IN' : 'OUT';

        switch (amountSide) {
            case 'IN':
                withEquivalentData = withEquivalentData.sort((a, b) => b.equivalentData.outAmount - a.equivalentData.outAmount);
                break;

            case 'OUT':
                withEquivalentData = withEquivalentData.sort((a, b) => a.equivalentData.inAmount - b.equivalentData.inAmount);
                break;
            
            default: return variantsArray;
        }

        return [
            ...withEquivalentData,
            ...withoutEquivalentData.filter(variant => variant.equivalentData),
            ...withoutEquivalentData.filter(variant => !variant.equivalentData)
        ];
    };

    const renderVariants = () => {
        if (!variantsArray.length) { return; }
        const providersArray = sortVariants(variantsArray);

        return (
            <div className="providerLazyLoad__control_wrapper">
                {
                    providersArray.map(providerData => {
                        return (
                            <div className="providerLazyLoad__variants_element">
                                <div>{ providerData.providerName }</div>
                                <div><span>In Amount: </span>{ providerData.equivalentData.inAmount }</div>
                                <div><span>Out Amount: </span>{ providerData.equivalentData.outAmount }</div>
                            </div>
                        );
                    })
                }
            </div>
        );
    };

    return(
        <>
            <CheckAuth />
            <div>
                { renderControl() }
                <hr/>
                { renderPercents() }
                { renderVariants() }
            </div>
        </>
    );
};
